import React from 'react'
import { useRouter } from 'next/router'

import styles from './styles.module.scss'

export const Back = () => {
	const router = useRouter()

	return (
		<button className={styles.backBtn} onClick={() => router.push('/faq')} type='button'>
			<svg
				width='12'
				height='22'
				viewBox='0 0 12 22'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M9.60938 20.9961C9.86719 21.2539 10.1953 21.3945 10.582 21.3945C11.3555 21.3945 11.9766 20.7852 11.9766 20.0117C11.9766 19.625 11.8125 19.2734 11.543 19.0039L3.33984 10.9883L11.543 2.99609C11.8125 2.72656 11.9766 2.36328 11.9766 1.98828C11.9766 1.21484 11.3555 0.605469 10.582 0.605469C10.1953 0.605469 9.86719 0.746094 9.60938 1.00391L0.492188 9.91016C0.164062 10.2148 0.0117188 10.5898 0 11C0 11.4102 0.164062 11.7617 0.492188 12.0781L9.60938 20.9961Z'
					fill='#1CA8E3'
				/>
			</svg>
			Назад
		</button>
	)
}
